enum PageType {
  AboutUs = 'About Us',
  AccessoriesHome = 'Accessories Home',
  Accessories = 'Accessories',
  Blog = 'Blog',
  Brochure = 'Brochure',
  BusinessElite = 'Business Elite',
  CPOVProgram = 'CPOV Program',
  CompetitiveAdvantage = 'Competitive Advantage',
  ContactUs = 'Contact Us',
  CustomDealerContent = 'Custom Dealer Content',
  DealerSpecials = 'Dealer Specials',
  DriverGear = 'DriverGear',
  FinancePrequalification = 'Finance Prequalification',
  Finance = 'Finance',
  Home = 'Home',
  HoursAndDirections = 'Hours & Directions',
  MaintenanceMenu = 'Maintenance Menu',
  ModelShowroom = 'Model Showroom',
  OEMIncentives = 'OEM Incentives',
  OnStar = 'OnStar',
  Other = 'Other',
  PageNotFound = 'Page Not Found',
  PartsHome = 'Parts Home',
  PartsOrderForm = 'Parts Order Form',
  PartsSpecials = 'Parts Specials',
  Parts = 'Parts',
  ScheduleService = 'Schedule Service',
  ServiceCreditCard = 'Service Credit Card',
  ServiceEvent = 'Service Event',
  ServiceHome = 'Service Home',
  ServiceSpecials = 'Service Specials',
  ServiceXpress = 'Service Xpress',
  Service = 'Service',
  Showroom = 'Showroom',
  TestDrive = 'Test Drive',
  TireStore = 'Tire Store',
  TradeIn = 'Trade In',
  VWCareMaintenance = 'VW Care Maintenance',
  VehicleDetails = 'Vehicle Details',
  VehicleListing = 'Vehicle Listing'
}

export default PageType;
